import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import Currency from 'ui/atoms/currency';
import BoxedContent from 'ui/molecules/boxed-content';
import { AdminProductOverview } from 'api';
import CardItem from 'src/ui/atoms/card-item';
import WideContent from 'src/core/layout/content/wide-content';

export interface ProductInvestmentsProps {
  data: AdminProductOverview;
}

const ProductInvestmentsOverview: FunctionComponent<ProductInvestmentsProps> = (props) => {
  const { data } = props;

  return (
    <WideContent ignorePageTitle titleSpacing="none">
      <BoxedContent title={<Translate name="common.investments" />}>
        <CardItem
          title={<Translate name="dashboardIssuerProductDetails.numberInvestments" />}
          content={data?.numberActiveInvestments}
        />
        <CardItem
          title={<Translate name="dashboardIssuerProductDetails.totalAmount" />}
          content={<Currency>{data?.sumActiveInvestments}</Currency>}
        />
        <CardItem
          title={<Translate name="dashboardIssuerProductDetails.sumPaymentsReceived" />}
          content={<Currency>{data?.sumPaymentsReceived}</Currency>}
        />
      </BoxedContent>
    </WideContent>
  );
};

export default ProductInvestmentsOverview;
